import "leaflet/dist/leaflet.css";
import { ReactNode } from "react";
import { MapContainer, MapContainerProps, TileLayer } from "react-leaflet";
import Constants from "../../../constants/Index";
import { ICoord } from "../../../@types/GoogleMaps/ICoord";
import { MapResizeHandler } from "../MapResizeHandler/Index";
import { LeafletInteractionHandler } from "../LeafletInteractionHandler/Index";

type LeafletMapProps = {
  children?: ReactNode;
  interactionOptions?: MapContainerProps;
  center?: ICoord;
};

export function LeafletMap({ children, interactionOptions = {}, center }: LeafletMapProps) {

  return (
    <MapContainer
      style={{ width: "100%", height: "100%", background: "transparent" }}
      center={center || Constants.DEFAULT_COORDS}
      zoom={9}
      minZoom={Constants.LEAFLET_ZOOM_MIN}
      maxZoom={Constants.LEAFLET_ZOOM_MAX}
      {...interactionOptions}
    >
      <TileLayer
        url="https://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}&s=Ga"
      />
      <MapResizeHandler />
      <LeafletInteractionHandler />
      {children}
    </MapContainer>
  );
}
